import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

/**
 * Converts a UTC date string from the database to the user's local timezone.
 * Usage: {{ dateFromDB | utcToLocal : 'medium' }}
 * Equivalent to the Angular date pipe format options.
 */
@Pipe({
	name: 'utcToLocal',
	pure: true,
})
export class UtcToLocalPipe implements PipeTransform {
	constructor(private datePipe: DatePipe) {}

	transform(value: any, format: string = 'MMM d, y, h:mm a'): string | null {
		if (!value) return null;

		let utcString = value.toString().trim();

		// If the string has no timezone info, treat it as UTC by appending 'Z'
		const hasTimezone =
			utcString.endsWith('Z') ||
			utcString.endsWith('z') ||
			/[+-]\d{2}:\d{2}$/.test(utcString) ||
			/[+-]\d{4}$/.test(utcString);

		if (!hasTimezone) {
			utcString = utcString + 'Z';
		}

		const date = new Date(utcString);

		if (isNaN(date.getTime())) return value;

		// DatePipe uses the browser's local timezone by default
		return this.datePipe.transform(date, format);
	}
}
